import { theme } from '@zappyrent/hundop';
import styled from 'styled-components';

export const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0.5rem 2.2rem;
  border-bottom: 0.3rem solid #029d9d;
  justify-content: space-between;
`;

export const DropDownContainer = styled.div``;

export const DropDownListContainer = styled.div`
  padding: 0.5rem 0;
  position: absolute;
  z-index: 100;
  display: none;
  &:hover {
    display: block;
  }
`;

export const DropDownHeader = styled.div<{ user: 'landlord' | 'tenant' }>`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 1rem;
  gap: 0.5rem;
  color: ${({ user }) => user && theme.colors[user].main};
  &:hover + ${DropDownListContainer} {
    display: block;
  }
`;

export const DropDownList = styled.ul`
  padding: 0.5rem;
  margin: 0;
  background: #ffffff;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: ${theme.colors.cross.grayson};
  font-size: 1.3rem;
  font-weight: 500;
  &:first-child {
    padding-top: 0.8em;
  }
`;

export const ListItem = styled.li<{ user: 'landlord' | 'tenant' }>`
  list-style: none;
  margin-bottom: 0.5em;
  &:hover {
    color: ${({ user }) => user && theme.colors[user].main};
  }
  cursor: pointer;
`;
